<template>
    <section class="select-section">
        <!-- 选择到期时间 -->
    <div class="select-items">
      <div>
        <span>结束时间：</span>
        <el-date-picker
          size="small"
          v-model="endTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间">
        </el-date-picker>
      </div>
      <div>
        <span>是否付费：</span>
        <el-select size="small"
         v-model="isPay"
         class="search-select"
         style="width: 70px">
          <el-option :value="false" label="否"></el-option>
          <el-option :value="true" label="是"></el-option>
        </el-select>
      </div>
      <div class="search-row" style="margin-bottom:0">
        <!-- 搜索条件 -->
        <el-input placeholder="请输入内容" v-model="selectVal.searchVal" class="input-with-select" @keyup.enter='getData' size='small'>
            <el-select style='width: 110px;' v-model="selectVal.searchKey" slot="prepend" placeholder="请选择">
                <el-option v-for='item in select.searchKey' :key='item.val'
              :value="item.val" :label="item.name"></el-option>
            </el-select>
            <el-button slot="append"  type="primary" size='small' @click='getData'>搜索</el-button>
        </el-input>
      </div>
    </div>
        <el-table border
            class='table_list'
            ref="memberTable"
            :data="memberTable"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="40px">
            </el-table-column>
            <el-table-column label="头像" width="80px">
                <template slot-scope="scope">
                    <img class="doc-header" :src="scope.row.head?commonUrl.imgPrefix_qN + scope.row.head:commonUrl.docHead_pic" />
                </template>
            </el-table-column>
            <el-table-column label="医生姓名" min-width="20%">
                <template slot-scope="scope">
                    <span>{{scope.row.realName?scope.row.realName:'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="职称" min-width="20%">
                <template slot-scope="scope">
                    <span>{{scope.row.jobTitle?scope.row.jobTitle:'-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="所属医院" min-width="20%">
                <template slot-scope="scope">
                    <span>{{scope.row.hospitalName?scope.row.hospitalName:'-'}}</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination class='el-pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
            </el-pagination>
        </div>
    </section>
</template>

<script scoped>
import courseApi from "@/api/contentManage/docCourseManage"
import commonApi from '@/api/common'
export default {
    name: "exportMember",
    data() {
      return {
      commonUrl: commonApi.commonUrl,
        select: {
            searchKey: [{
                val: 'phone',
                name: '手机号'
            }]
        },
        selectVal: {
            searchKey: 'phone',
            searchVal: ''
        },
        memberTable: [],
        memberChoose: [],
        currentPage: 1,
        endTime: '',
        isPay: false,
        pageSize: 20,
        totalCount: 0,
      }
    },
    props: {
      show: Boolean
    },
    mounted() {
        this.getData()
    },
    watch: {
      show(val) {
        if(val){
          this.selectVal = {
              searchKey: 'phone',
              searchVal: ''
          },
          this.endTime = ''
          this.isPay = false
          this.$refs.memberTable.clearSelection();
          this.getData()
        }
      }
    },
    methods: {
        init() {
            this.selectVal = {
                searchKey: 'phone',
                searchVal: ''
            },
            this.endTime = ''
            this.$refs.memberTable.clearSelection();
            this.getData()
        },
        getData() {
            var params = {
                page: this.currentPage,
                pageSize: this.pageSize,
                searchKey: this.selectVal.searchKey,
                searchValue: this.selectVal.searchVal
            };
            courseApi.getMemberList(params).then(res => {
            if (res.Success) {
              this.memberTable = res.Data.dataList;
              this.totalCount = res.Data.totalCount;
            } else {
              this.$message.error(res.Msg);
            }
          }).catch(res => {
            this.$message.error('列表获取出错，请刷新重试！')
          })
        },
        chooseData() {
            return this.memberChoose
        },
        chooseTime() {
          return this.endTime
        },
        choosePay() {
          return this.isPay
        },
        handleSelectionChange(val) {
            this.memberChoose = val;
        },
        handleSizeChange(val) {
          this.pageSize = val;
          this.getData();
        },
        handleCurrentChange(val) {
          this.currentPage = val;
          this.getData();
        }
    },
    filters: {
    }
};
</script>

<style type="text/less" lang="less" scoped>
.select-section {
    height: 500px;
    overflow-y: auto;
    .select-items{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 10px 0 20px 0;
      >div{
        white-space: nowrap;
        max-width: 380px;
      }
    }
  .el-dialog__wrapper {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .pagination-wrap {
    margin-top: 10px;
  }
  .el-pagination {
    float: right;
  }
  .dialog-footer {
    margin-top: 40px;
  }
}
.search-row {
  margin-bottom: 10px;
  .input-with-select {
    width: 400px;
  }
  .search-select {
    width: 140px;
  }
}
.search-row>div{
    margin: 5px 5px 5px 0;
    max-width: 270px;
}
.doc-header {
  width: 60px;
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/contentManage/docCourseManage/exportMember.vue